import { type ImgHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE } from '../../i18n'

export type LocalizedImageSources = Partial<Record<string, string>> &
  Record<typeof DEFAULT_LANGUAGE, string>

interface LocalizedImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  sources: LocalizedImageSources
}

export const LocalizedImage = ({ sources, alt = '', ...rest }: LocalizedImageProps) => {
  const { i18n } = useTranslation()
  const language = i18n.language.split('-')[0].toLowerCase()
  const source = sources[language] ?? sources[DEFAULT_LANGUAGE]

  return <img alt={alt} src={source} {...rest} />
}
